import { useAtom } from 'jotai';
import { showSolarOptionsAtom, showSolarsViewAtom } from '../states/planner';

import useSolars from '../hooks/useSolars';
import { SolarType } from '../CommonTypes';
import tomodal from '../assets/tomodal.svg';

export const SolarOptions = ({
  currentSolar,
  onChange,
}: {
  currentSolar: SolarType | null;
  onChange: (solar: SolarType) => void;
}) => {
  const [showSolarOptions, setShowSolarOptions] = useAtom(showSolarOptionsAtom);
  const [, setShowSolarsView] = useAtom(showSolarsViewAtom);
  const [solars] = useSolars();

  if (!solars || solars.length === 0) return <></>;
  if (!currentSolar) return <></>;

  return (
    <>
      <div
        className={`z-1 absolute left-0 top-0 h-full w-full cursor-default ${showSolarOptions ? 'visible' : 'invisible'}`}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setShowSolarOptions(false)}
        onClick={() => setShowSolarOptions(false)}
      ></div>
      <div
        id="solar-tooltip"
        className={`z-2 absolute right-2 top-2 transform rounded-md bg-black/60 bg-white p-3 text-white shadow-lg transition-all duration-300 ease-out ${
          showSolarOptions ? 'visible scale-100 opacity-90' : 'invisible scale-75 opacity-0'
        }`}
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          borderRadius: '0.375rem',
          padding: '0.5rem 0',
        }}
      >
        <ul className="max-h-64 overflow-y-auto text-sm">
          {solars.map(solar => (
            <li key={solar.id}>
              <button
                className={`block w-full px-4 py-2 text-left hover:bg-white/10 ${
                  currentSolar.id === solar.id ? 'text-green-400' : ''
                }`}
                onClick={() => {
                  onChange?.(solar);
                }}
              >
                {solar.date} <span className="ml-5">{solar.time}</span>
              </button>
            </li>
          ))}
        </ul>
        <button
          className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm hover:bg-white/10"
          onClick={() => setShowSolarsView(true)}
        >
          <span>Visa Solstudie</span>
          <img src={tomodal} alt="open modal" className="" />
        </button>
      </div>
    </>
  );
};
